import { useEffect } from 'react'

// True only in the iOS build (`--mode ios`, client/.env.ios). That build keeps
// the native splash up until the first render (`launchAutoHide: false` in
// capacitor.config.ts), so a warm cache opens straight onto content.
//
// Defined here and not in config.ts: Rolldown only leaves the Capacitor chunk
// out of the website build when this constant sits in the same module as the
// dynamic import below.
const NATIVE = import.meta.env.VITE_NATIVE === 'true'

// Hides the native splash once the first render commits. Without a cached
// session that render is the in-app splash, which waits on /auth/me.
export const useHideSplash = (): void => {
	useEffect(() => {
		if (!NATIVE) return
		void import('@capacitor/splash-screen')
			.then(({ SplashScreen }) => SplashScreen.hide())
			.catch(() => {})
	}, [])
}
